import { Component, OnInit } from '@angular/core';
import { PreformanceStatusService } from '../service/preformance-status.service'
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-preformance-status-detailed',
  templateUrl: './preformance-status-detailed.component.html',
  styleUrls: ['./preformance-status-detailed.component.css']
})
export class PreformanceStatusDetailedComponent implements OnInit {

  arrMonth: any[] = [];
  selectedMonth: any = null;
  selectOptionDDL: null;
  cols: any[];
  resultTable: any[] = null;
  msgs: any[] = [];
  gapReport: any[] = null;
  accountManagers: any[];
  accountManagerSelected: any = null;
  customers: any[];
  customersSelected: any[];



  constructor(private dataService: PreformanceStatusService, private router: Router) { }
  ngOnInit() {

    this.dataService.GetMonths().subscribe((result: any) => {
      this.arrMonth = result;
      this.selectedMonth = this.arrMonth[this.arrMonth.length - 1];
    });

    this.dataService.getAccountManagersDDL().subscribe((result: any) => {
      this.accountManagers = result;
      //if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length == 1) {
      //  this.accountManagerSelected = this.accountManagers[0].value;
      //}
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });
    
  }

  getData() {          //////////////////////////////////////////////////////////
      this.cols = [
        { field: 'IdentityNumber', header: 'ח.פ. מעסיק' },
        { field: 'CustomerName', header: 'שם מעסיק' },
        { field: 'Active', header: 'פעיל' },
        { field: 'isReported', header: 'האם דיווח' },
        // { field: 'HodsheiSahar', header: 'חודשי שכר - שוטף' },
        { field: 'HodeshSahar', header: 'חודש שכר - שוטף' },
        { field: 'MaximumEmployees', header: 'מספר עובדים מקסימלי' },
        { field: 'MisparOvdimDuvhuShotef', header: 'מספר עובדים דווחו - שוטף' },
        { field: 'MisparOvdimDuvhuShotefPercent', header: 'מספר עובדים שדווחו שוטף - אחוז לעומת מקסימום' },
        { field: 'PotentialGvia', header: 'פוטנציאל גביה' },
        { field: 'TotalCostCalculatedResultActualShotef', header: 'סכום גביה שוטף' },
        { field: 'TotalCostCalculatedResultActualShotefPercent', header: 'אחוז גביה שוטף לעומת מקסימום' },
        { field: 'TotalCostCalculatedResultCompletion', header: 'גביה משלימים' },
        { field: 'TotalCountCalculatedResultCompletion', header: 'מספר משלימים' },
        { field: 'PercentageRecieved', header: 'אחוז נקלטו ע"י היצרן' },
        { field: 'PercentageDenied', header: 'אחוז נדחו ע"י היצרן' },
        { field: 'PercentageNotRecievedYet', header: 'אחוז טרם התקבל מענה' },
        { field: 'PercentageTransferedToManufacturerTreatment', header: 'אחוז הועבר להמשך טיפול אצל יצרן' },
        
      ];

      this.dataService.getDataDetailed(this.accountManagerSelected, this.customersSelected, this.selectedMonth).subscribe((result: any) => {
          this.resultTable = result;

        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהצגת הדוח');
        });
  }

  //CreateExcelSpecialData() {
  //  try {
  //    var d = new Date();
  //    let fileName = 'PaymentReportSpecialExport.' + d.getFullYear().toString() + '.csv';
  //    this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
  //    this.dataService.downloadExcelSpecialData(this.selectOptionDDL == null ? "" : this.selectOptionDDL, this.selectedMonth, this.isGapDataView).subscribe((result: any) => {
  //      window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
  //      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //        window.navigator.msSaveOrOpenBlob(result, fileName);
  //      }
        
  //      let url = window.URL.createObjectURL(result)
  //      let link = document.createElement('a');
  //      link.href = url;
  //      link.download = `${fileName}`;
  //      link.click();
  //      setTimeout(() => {
  //        this.showMessage('success', '', 'הקובץ נבנה בהצלחה');
  //      }, 1000);
  //    }, (err: HttpErrorResponse) => {
  //      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
  //    });
  //  } catch (error) {
  //    this.showMessage('error', '', 'תקלה בהורדת הקובץ');
  //  }
  //}

  accountManagersChanged() {
    this.dataService.getCustomers(this.accountManagerSelected).subscribe((result: any) => {
      this.customers = result;
      this.customersSelected = [];
    
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
    });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/preformance-status-detailed/preformance-status-detailed.component.ts